const state = () => ({
  token: localStorage.getItem('token') || '',
  user: JSON.parse(localStorage.getItem('user') || '{}'),
})

const mutations = {
  setToken(currentState, token) {
    currentState.token = token || ''
    if (token) {
      localStorage.setItem('token', token)
      return
    }
    localStorage.removeItem('token')
  },
  setUserInfo(currentState, user) {
    currentState.user = user || {}
    localStorage.setItem('user', JSON.stringify(currentState.user))
  },
  logout(currentState) {
    currentState.token = ''
    currentState.user = {}
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
